import styled from 'styled-components';

export const HelpModalContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    padding: 1rem 0;
`;

export const HelpButton = styled.button`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    border: 2px solid #e0e0e0;
    border-radius: 12px;
    background-color: #ffffff;
    cursor: pointer;
    transition: all 0.3s ease;
    gap: 1rem;

    &:hover {
        border-color: #3a6647;
        background-color: #f5f9f6;
        transform: translateY(-2px);
        box-shadow: 0px 4px 12px rgba(58, 102, 71, 0.15);
    }

    h3 {
        margin: 0;
        color: #3a6647;
        font-size: 1.2rem;
        font-weight: 600;
    }

    p {
        margin: 0;
        color: #666666;
        font-size: 0.95rem;
        text-align: center;
        line-height: 1.4;
    }

    svg {
        width: 48px;
        height: 48px;
        color: #3a6647;
    }
`;
